<template>
    <hello-client></hello-client>
    <div v-if="cprofile">
        <img src="@/assets/hello-hi.gif" class="hello" alt="hello">
        <span class="cprofile">{{cprofile.fname}} {{cprofile.lname}}</span>
    </div>
    <div class="container-shader">

    </div>
</template>

<script>
// @ is an alias to /src
import {getClientProfile} from "../hid.js"
import HelloClient from "../components/HelloClient.vue";
export default {
  name: 'Client',
  components: {
      HelloClient,
  },
    data() {
        return {
            cprofile:null
        }
    },
    mounted() {
        // get profile if UI customer
        if(!this.$store.getters.getBusiness) {
            //console.log('ui customer')
            this.cprofile = getClientProfile()
        }
    },
}
</script>

<style lang="scss" scoped>
    body {
        background-color: black;
        height: 100vh;
    }
    .container-shader{
        padding: 10px 30%;
        margin-top: 120vh;
    }
    .cprofile {
        color: black;
        font-weight: bold;
        font-family: Papyrus;
        font-size: 16px;
    }
    .hello {
        width: 10%;
        height: 10%;
        padding-top: 15px;
        padding-left: 50%;
        //border-radius: 50%; !! SAFARI problem
    }
    /* Change styles for main image  - phones screens */
    @media screen and (max-width: 414px) {

        img {
            width: 200px;
        }
        .cprofile {
            font-size: 10px;
        }
        .hello {
            width: 10%;
            height: 10%;
        }
    }

</style>
